export const imagesKeyToPreloadInApp = [
    "gameBackgroundUrl"
]

export const imagesToPreloadInApp = [
    "/404-page.png",
    "/connection-lost.png"
]

export const imagesToPreloadInSlotMachine = [
    "/slot-machine-bg.png",
    "/slot-machine-reel-bg.png",
    "/machine-separator.png",
    "/volume-high-blue.png",
    "/infinity-white.png",
    // "/plus-bet-bg.png",
    // "/minus-bet-bg.png",
    "/export.png",
    "/minus-white.png",
    "/plus-green.png",
    "/on.png",
    "/off.png",
    "/win-result-bg.png",
    "/win-free-spin-bg.png",
    "/feature-win-free-spin-bg.png",
    "/total-win-free-spin-bg.png",
    "/continue-free-spin-bg.png",
    "/0.png",
    "/1.png",
    "/2.png",
    "/3.png",
    "/4.png",
    "/5.png",
    "/6.png",
    "/7.png",
    "/8.png",
    "/9.png",
    "/point.png",
    // "/404-page.png",
    // "/connection-lost.png"
]

// export const imagesToPreload = [
//     "/volume-high-blue.png",
//     "/infinity-white.png",
//     "/plus-bet-bg.png",
//     "/minus-bet-bg.png",
//     "/export.png",
//     "/minus-white.png",
//     "/plus-green.png",
//     "/on.png",
//     "/off.png",
//     "/win-result-bg.png",
//     "/win-free-spin-bg.png",
//     "/feature-win-free-spin-bg.png",
//     "/total-win-free-spin-bg.png",
//     "/continue-free-spin-bg.png",
//     "/0.png",
//     "/1.png",
//     "/2.png",
//     "/3.png",
//     "/4.png",
//     "/5.png",
//     "/6.png",
//     "/7.png",
//     "/8.png",
//     "/9.png",
//     "/point.png"
// ];

export const imageKeysToPreloadInSlotMachine = [
    "navbarBackgroundUrl",
    "spinButtonUrl",
    "autoPlayButtonUrl",
    "plusButtonUrl",
    "minusButtonUrl",
    "payLinesButtonUrl",
    "turboButtonUrl",
    "turboOnButtonUrl",
    "settingsButtonUrl",
    "soundButtonUrl",
    "infoButtonUrl",
]

export const audioKeysToPreloadInSlotMachine = [
    // "baseAudioUrl",
    "normalButtonAudioUrl",
    "reelStopAudioUrl",
    "turboReelStopAudioUrl",
    "bonusAudioUrl",
    "wildAudioUrl",
    "featureWinAudioUrl",
    "totalWinAudioUrl"
]

export const preloadImages = (srcArray) => {
    return Promise.all(
        srcArray.map((src) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;

                img.onload = () => {
                    // console.log(`✅ Loaded: ${src}`);
                    resolve(src);
                };
                img.onerror = (err) => {
                    console.error(`❌ Failed to load: ${src}`, err);
                    reject(new Error(`Failed to load image: ${src}`));
                };
            });
        })
    );
};

export const preloadAudios = (srcArray) => {
    return Promise.all(
        srcArray.map((src) => {
            return new Promise((resolve, reject) => {
                const audio = new Audio();
                audio.crossOrigin = "anonymous"
                audio.src = src;

                audio.oncanplaythrough = () => {
                    // console.log(`✅ Audio loaded: ${src}`);
                    resolve(src);
                };
                audio.onerror = (err) => {
                    console.error(`❌ Failed to load audio: ${src}`, err);
                    reject(new Error(`Failed to load audio: ${src}`));
                };

                audio.load();
            });
        })
    );
};